var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9997 7.00082L22.9997 7.00164L22.9985 21.0016L2.99852 21L3 3L13 3.00082L12.9997 7.00082ZM4.99869 19.0002L6.99869 19.0003L6.99885 17.0003L4.99885 17.0002L4.99869 19.0002ZM6.99902 15.0003L4.99902 15.0002L4.99918 13.0002L6.99918 13.0003L6.99902 15.0003ZM4.99934 11.0002L6.99934 11.0003L6.99951 9.00033L4.99951 9.00016L4.99934 11.0002ZM6.99967 7.00033L4.99967 7.00016L4.99984 5.00016L6.99984 5.00033L6.99967 7.00033ZM8.99869 19.0005L10.9987 19.0007L10.9989 17.0007L8.99885 17.0005L8.99869 19.0005ZM10.999 15.0007L8.99902 15.0005L8.99918 13.0005L10.9992 13.0007L10.999 15.0007ZM8.99934 11.0005L10.9993 11.0007L10.9995 9.00066L8.99951 9.00049L8.99934 11.0005ZM10.9997 7.00066L8.99967 7.00049L8.99984 5.00049L10.9998 5.00066L10.9997 7.00066ZM20.9987 19.0015L20.9995 9.00148L12.9995 9.00082L12.9993 11.0008L14.9993 11.001L14.9992 13.001L12.9992 13.0008L12.999 15.0008L14.999 15.001L14.9989 17.001L12.9989 17.0008L12.9987 19.0008L20.9987 19.0015ZM18.9993 11.0013L16.9993 11.0011L16.9992 13.0011L18.9992 13.0013L18.9993 11.0013ZM16.999 15.0011L18.999 15.0013L18.9989 17.0013L16.9989 17.0011L16.999 15.0011Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness24Px);
export default __webpack_public_path__ + "static/media/business_24px.b849df80ed078296edf8e903c75cdd3e.svg";
export { ForwardRef as ReactComponent };